// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
export const getCookieAsJson = <T>(
  allCookies: string,
  cookieName: string,
): T | null => {
  const cookies = allCookies.split('; ');
  const cookie = cookies.find((cookie) => cookie.startsWith(`${cookieName}=`));
  if (!cookie) return null;

  const cookieValue = cookie.split('=')[1];
  try {
    const parsed = JSON.parse(decodeURIComponent(cookieValue)) as unknown;
    return parsed as T;
  } catch {
    return null;
  }
};

export const isConsentGiven = (): boolean => {
  const cookie = getCookieAsJson<{ action: string }>(
    document.cookie,
    'CookieScriptConsent',
  );
  return cookie ? cookie.action === 'accept' : false;
};
